import { render, staticRenderFns } from "./AddCustomerPage.vue?vue&type=template&id=03380d1c"
import script from "./AddCustomerPage.vue?vue&type=script&lang=js"
export * from "./AddCustomerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports